import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationMapService,
  PlaceModel,
  LatLonModel,
  TrackingModel,
  VehiclesMapModel
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationMapApiService {
  constructor(private apiService: AdministrationMapService) {}

  public getDistancesBetweenCoordinates(latLonModel: LatLonModel[], vehiclesMap?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PlaceModel[]> {
    return this.apiService.adminMapDistanceGet(latLonModel, vehiclesMap, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getPlace(latLonModel: LatLonModel, vehiclesMap?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PlaceModel> {
    return this.apiService.adminMapPlaceGet(latLonModel, vehiclesMap, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getTracking(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<TrackingModel> {
    return this.apiService.adminMapTrackingGet(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getVehiclesMap(requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehiclesMapModel[]> {
    return this.apiService.adminMapVehiclesGet(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
